var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SchoolLeaveEntitlementTable',{attrs:{"items":_vm.items,"is-busy":_vm.isBusyStore,"pagination":_vm.pagination},on:{"navigateToIndividual":function($event){return _vm.goToStaffEntitlement($event.item)},"row-clicked":_vm.goToStaffEntitlement}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }